import axiosInstance, { endpoints } from 'src/utils/axios';

let globalAppDetails = null;

export async function loadMsalConfig() {
  if (!globalAppDetails) {
    const response = await axiosInstance.get(endpoints.auth.global_app_details);
    globalAppDetails = response.data;
  }

  const { clientId, redirectUri } = globalAppDetails;

  return {
    auth: {
      clientId: clientId ?? '443212e5-5f3d-4644-98d3-795ac5c661b4',
      authority: 'https://login.microsoftonline.com/organizations',
      redirectUri,
      postLogoutRedirectUri: redirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      allowNativeBroker: false,
    },
  };
}


export async function getGlobalAppDetails() {
  if (!globalAppDetails) {
    const response = await axiosInstance.get(endpoints.auth.global_app_details);
    globalAppDetails = response.data;
  }
  return globalAppDetails;
}